import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import routes from './routes'
import verify from "./vue-verify-plugin/src"
import infiniteScroll from "vue-infinite-scroll"
import touch from 'vue-plugin-touch';
import {httpGet} from '../../api/base.js'
import config from '../../config/config.js'
import '@babel/polyfill';

// import verify from "./assets/js/plugins"
//css
import "./assets/css/common.scss"
import "./assets/css/aboutme.scss"
import "./assets/css/care.scss"
import "./assets/css/explorer.scss"

import "./assets/css/birthday.scss"

import "./assets/css/birthday_sz.scss"
import "./assets/css/app.scss"
import "./assets/css/b-birthday-board.scss";



(function () {
    
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }
    function handleFontSize() {
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        });
    }
})();


function formatComponentName(vm)
{
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');

}

Vue.config.errorHandler = function(err, vm, info)
{
  var componentName = formatComponentName(vm);
  var propsData = vm.$options && vm.$options.propsData;

//   fundebug.notifyError(err,
//   {
//       metaData:
//       {
//           componentName: componentName,
//           propsData: propsData,
//           info: info
//       }
//    });
};


//filter
import * as birthdayFilter from "./component/birthday/filter/filter"



var myRules = {

  phone: {
    test: function (val) {
      if (/^1\d{10}$/.exec(val)) {
        return true
      } else {
        return false;
      }
    },
    message: "手机号码格式不正确"
  }

}
Object.keys(birthdayFilter).forEach(key => {
  Vue.filter(key, birthdayFilter[key])
})
Vue.config.debug = true
Vue.prototype.project_name = config.project_name;
Vue.use(infiniteScroll)
Vue.use(verify, {
  rules: myRules
});
Vue.use(VueRouter)
Vue.use(touch)
const router = new VueRouter({
  // mode:'history', //这样url就没有/#/XXX,而是常见的url形式
  routes, // short for routes: routes
  linkActiveClass: 'active', //router-link的选中状态的class，也有一个默认的值
  // history:true
});
router.beforeEach((to, from, next) => {


    
    if((!window.show_open_data || window.show_open_data === undefined) && config.project_name !== 'changjiangcunchu'){
      window.wxActions =  new WxRecord(
            function (res){
                window.show_open_data = true;
                if(res.result == 'success'){
                    window.use_open_data = true;
                }else{
                    console.log(res.msg,res.error)
                }
                next()
            },
            {type:'opendata'}
        );
    }else{
        next()
    }
})
//统计代码
router.afterEach(route => {
  if (document.getElementsByTagName('body')[0].className != "routeReady") {
      setTimeout(function(){
        document.getElementsByTagName('body')[0].className = "routeReady"
      },500)
  }
});

//处理地址
(function () {
  let arr = [];
  let provinceData=[];
  if (global_regions) {
    global_regions[-1].forEach((item,i) => {
      let vitem = {
        "value": item.id.toString(),
        "name": item.name,
        "id":item.id.toString()
      }
      arr.push(vitem)
      vitem.title=item.name
      provinceData.push(vitem)
    })
    for (var key in global_regions) {
      if (key != -1) {
        global_regions[key].forEach((item,i) => {
          let vitem = {
            "value": item.id.toString(),
            "name": item.name,
            "parent": key,
            "id":item.id.toString()
          }
          global_regions[key][i].title=item.name
          global_regions[key][i].parent=key
          arr.push(vitem)
        })
      }

    }
    window.globalRegions=global_regions;
  }
  
  window.areaData = arr;
  window.provinceData = provinceData;
  // console.log("addressValue",window.areaData)

}());

window.HTTPSTATUS = new Vue();

var _isWxWork = (function() {
    var ua = window.navigator.userAgent.toLowerCase();
    return /wxwork/i.test(ua);
})()

var _isWx = (function() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") !== -1;
  })();


//企业微信使用1.2.0 调用opendata组件

if(_isWx){
    loadjs(['//res.wx.qq.com/open/js/jweixin-1.4.0.js'], 'jweixin');
}else{
    loadjs(['//res.wx.qq.com/open/js/jweixin-1.2.0.js'], 'jweixin');
}

loadjs.ready('jweixin', function() {
    loadjs(['//open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'], 'jwxwork');
    loadjs.ready('jwxwork', function() {
        new Vue({
            store,
            router
        }).$mount('#app')
    })
});


